import { render, staticRenderFns } from "./ProjectTime.vue?vue&type=template&id=52fec2b2&scoped=true&"
import script from "./ProjectTime.vue?vue&type=script&lang=js&"
export * from "./ProjectTime.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTime.vue?vue&type=style&index=0&id=52fec2b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fec2b2",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52fec2b2')) {
      api.createRecord('52fec2b2', component.options)
    } else {
      api.reload('52fec2b2', component.options)
    }
    module.hot.accept("./ProjectTime.vue?vue&type=template&id=52fec2b2&scoped=true&", function () {
      api.rerender('52fec2b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/projects/ProjectTime.vue"
export default component.exports